import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-surface border-t border-dark-border mt-20">
      <div className="max-w-7xl mx-auto content-padding py-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          {/* Copyright */}
          <div className="text-dark-muted text-sm">
            © {currentYear} HyperionAI. All rights reserved.
          </div>

          {/* Legal Links */}
          <div className="flex items-center space-x-6">
            <Link 
              to="/terms" 
              className="text-dark-muted hover:text-brand text-sm transition-colors duration-300"
            >
              Terms of Service
            </Link>
            <Link 
              to="/privacy" 
              className="text-dark-muted hover:text-brand text-sm transition-colors duration-300"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

